import { render, staticRenderFns } from "./root-services-ongoing.vue?vue&type=template&id=2a61c986"
import script from "./root-services-ongoing.vue?vue&type=script&lang=js"
export * from "./root-services-ongoing.vue?vue&type=script&lang=js"
import style0 from "./root-services-ongoing.vue?vue&type=style&index=0&id=2a61c986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports